(function (angular) {
    'use strict';

    angular.module('app')
        .service('EventsApi', eventsResource);

    eventsResource.$inject = [
        'settings',
        '$resource',
        'extendResource'
    ];

    function eventsResource(
        settings,
        $resource,
        extendResource
    ) {
        /**
         * Formats the address, omitting any blank pieces
         * @return {string} - event address
         */
        function getAddress() {
            var _this = this,
                address = [],
                order = [
                    'line_1',
                    'line_2',
                    'town_city',
                    'county',
                    'postcode'
                ];
            angular.forEach(order, function (index) {
                if (_this.address && _this.address[index] !== undefined && _this.address[index] !== '') {
                    address.push(_this.address[index]);
                }
            });
            return address.join(', ');
        }

        /**
         * Adds extra methods and values. Expects "this" to be bound to an event object
         * @return {this}
         */
        function transform() {
            this.getAddress = getAddress;

            return this;
        }

        // Create the resource
        var resource = $resource(settings.apiBase + '/events/:id', {
            id: '@id'
        }, {
            get: {
                method: 'GET',
                responseType: 'json',
                transformResponse: function (response) {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }

                    if (Array.isArray(response.data)) {
                        angular.forEach(response.data, function (event) {
                            transform.call(event);
                        });
                    } else {
                        if (response.data) {
                            transform.call(response.data);
                        }
                    }

                    return response;
                }
            },
            update: {
                method: 'PUT',
                responseType: 'json',
                transformResponse: function (response) {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }

                    if (response.data) {
                        transform.call(response.data);
                    }
                    return response;
                }
            }
        });
        resource.prototype.transform = transform;

        return extendResource(resource);
    }

}(angular));
